import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class RemainingEstimate extends Field {
  static subqueriesForModel() {
    return { remainingEstimate: ['text'] };
  }

  get title() {
    return 'Remaining estimate';
  }

  exampleContents(): FieldContentsData {
    return { text: '3d', icon: { name: 'fa-regular fa-clock' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.remainingEstimate?.text) {
      return {
        text: record.remainingEstimate.text,
        icon: { name: 'fa-regular fa-clock' },
      };
    }

    return {};
  }
}
